import {Component, Input} from '@angular/core';
import {Events, PopoverController} from "ionic-angular";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";
import { cloneDeep } from 'lodash';

@Component({
    selector: 'booking-totals',
    templateUrl: 'booking-totals.html'
})
export class BookingTotalsComponent {

    @Input() set booking(response: any) {
      response.services = this.deleteIconFromName(response.services);
      // if (response.services) {
      //     response.services = cloneDeep(this.bookingService.proccessCoffeShopServices(response.services, response.id));
      // }
      this.bookingValue = response;
    };
    public bookingValue: any = null;
    @Input() currencySymbol;
    @Input() isHideExtrafields = false;
    constructor(
      public events: Events,
      public popoverCtrl: PopoverController,
      public bookingService: BookingServiceProvider
    ) {

    }

    ngOnChanges(){

    }

    amountDue(booking) {
      return this.bookingService.getAmountDue(booking);
    }

    amountPaid(booking) {
      return this.bookingService.getAmountPaid(booking);
    }

    parseNumber(number){
      return Number(number);
    }
    private deleteIconFromName(services: any[]): any[] {
      if (!services || !services.length) { return; }
      return services.map((service: any) => {
        if (!service.name) { return service; }
        const latters: string[] = service.name.split('').filter((latter: string) => latter !== "\ud83c" && latter !== "\udd93");
        latters[latters.length-1] === ' ' ? latters.pop() : null;
        service.name = latters.join('');
        return service;
      });
    }

}



// WEBPACK FOOTER //
// ./src/components/booking-totals/booking-totals.ts